var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _mask, _g, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGitcoinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 122,
    viewBox: "0 0 86 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2393 58.6172L69.8207 73.5519L64.0683 97.9775L50.3691 86.7859L52.77 68.8694L62.2393 58.6172Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0023 53.6136C40.4263 53.6136 39.1465 52.3349 39.1465 50.7578V28.2531C39.1465 26.6771 40.4263 25.3984 42.0023 25.3984C43.5782 25.3984 44.858 26.6771 44.858 28.2531V50.7578C44.858 52.3349 43.5782 53.6136 42.0023 53.6136Z",
    fill: "#15003E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.583 53.6139H37.7581C36.181 53.6139 34.9023 52.3352 34.9023 50.7581C34.9023 49.181 36.181 47.9023 37.7581 47.9023H46.583C48.159 47.9023 49.4388 49.181 49.4388 50.7581C49.4388 52.3352 48.159 53.6139 46.583 53.6139Z",
    fill: "#15003E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2391 58.6168L71.6211 49.7737C64.4425 42.594 54.5239 38.1543 43.5682 38.1543C21.6568 38.1543 3.89355 55.9153 3.89355 77.8267C3.89355 99.738 21.6568 117.501 43.5682 117.501C51.735 117.501 58.9182 120.483 65.2277 116.252L73.0791 117.339L72.8544 104.591L50.369 86.7854L55.2035 64.0175L62.2391 58.6168Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5674 121.395C19.5446 121.395 0 101.851 0 77.8283C0 53.8044 19.5446 34.2598 43.5674 34.2598C55.205 34.2598 66.1459 38.7925 74.374 47.0206L77.2105 49.856L64.9104 61.4504L59.5687 55.7831L65.8714 49.8435C59.5573 44.79 51.7728 42.0476 43.5674 42.0476C23.8379 42.0476 7.78675 58.0977 7.78675 77.8283C7.78675 97.5567 23.8379 113.608 43.5674 113.608",
    fill: "#15003E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4358 99.0164L59.8434 93.5976C63.962 89.3474 66.2289 83.7481 66.2289 77.8289C66.2289 71.6511 63.7884 65.8782 59.3555 61.5724L56.4385 58.7382L59.5666 55.7871L62.2329 58.61L64.7812 55.9868C70.7367 61.771 74.0168 69.5282 74.0168 77.8289C74.0168 85.7813 70.9693 93.3049 65.4358 99.0164Z",
    fill: "#0FCE7C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6094 77.8287C34.6094 72.8819 38.6202 68.8711 43.567 68.8711C48.5139 68.8711 52.5247 72.8819 52.5247 77.8287C52.5247 82.7756 48.5139 86.7864 43.567 86.7864C38.6202 86.7864 34.6094 82.7756 34.6094 77.8287Z",
    fill: "#EFF4EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5673 72.7644C40.7739 72.7644 38.5035 75.0359 38.5035 77.8282C38.5035 80.6204 40.7739 82.893 43.5673 82.893C46.3606 82.893 48.631 80.6204 48.631 77.8282C48.631 75.0359 46.3606 72.7644 43.5673 72.7644ZM43.5673 90.6798C36.4817 90.6798 30.7168 84.9149 30.7168 77.8282C30.7168 70.7426 36.4817 64.9766 43.5673 64.9766C50.6528 64.9766 56.4188 70.7426 56.4188 77.8282C56.4188 84.9149 50.6528 90.6798 43.5673 90.6798Z",
    fill: "#15003E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6238 73.553L46.3389 67.8335L68.9786 46.916L74.2636 52.6344L51.6238 73.553Z",
    fill: "#15003E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7939 85.7266L64.0675 97.9768L72.8538 104.592V121.395L55.2029 120.545",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7485 121.397H42.8604V113.609H68.9606V106.536L45.4529 88.8393L50.1365 82.6172L76.7485 102.65V121.397Z",
    fill: "#15003E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7531 30.3947L82.6319 33.516L79.5117 30.3947L82.6319 27.2734L85.7531 30.3947Z",
    fill: "#25E899"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0797 15.3514L67.5877 16.8434L66.0957 15.3514L67.5877 13.8594L69.0797 15.3514Z",
    fill: "#25E899"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 0,
    width: 5,
    height: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0801 0H84.5788V4.49948H80.0801V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5788 2.24991C84.5788 1.00752 83.5712 0 82.3288 0C81.0865 0 80.0801 1.00752 80.0801 2.24991C80.0801 3.49229 81.0865 4.49982 82.3288 4.49982C83.5712 4.49982 84.5788 3.49229 84.5788 2.24991Z",
    fill: "#25E899"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4866 61.473C26.9107 61.473 25.6309 60.1943 25.6309 58.6172V28.2531C25.6309 26.676 26.9107 25.3984 28.4866 25.3984C30.0626 25.3984 31.3424 26.676 31.3424 28.2531V58.6172C31.3424 60.1943 30.0626 61.473 28.4866 61.473Z",
    fill: "#15003E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitcoinLogo);
export default __webpack_public_path__ + "static/media/gitcoin-logo.4d7b8dbd19bac8f843ab5a9bf356d738.svg";
export { ForwardRef as ReactComponent };